import React, {Suspense} from "react";

import {BlogShell} from "./MainPages/BlogEntrieShell/BlogEntryShell";
import {MyLoader} from "./BlogEntries/utils";

import settings from "../settings.json";

const HomePage = React.lazy(()=>import("./MainPages/HomePage"))
const AboutPage = React.lazy(()=>import("./MainPages/AboutPage/AboutPage"))
const ImpressumPage = React.lazy(()=>import("./MainPages/ImpressumPage"))
const ContactPage = React.lazy(()=>import("./MainPages/ContactPage"))

const ErrorPage = React.lazy(()=>import("./ErrorPages/404ErrorPage"))

const Sambia = React.lazy(()=>import("./BlogEntries/AboutSambia"))
const Freiwilligendienst = React.lazy(()=>import("./BlogEntries/AboutFreiwilligendienst"))
const ArrivePage = React.lazy(()=>import("./BlogEntries/Arrival"))
const DonationsPage = React.lazy(()=>import("./BlogEntries/Donations"))
const AboutMyWork = React.lazy(()=>import("./BlogEntries/MyWork"))
const EverydayLife = React.lazy(()=>import("./BlogEntries/EverydayLife"))
const BlogBrot = React.lazy(()=>import("./BlogEntries/BrotBlogeintrag"))
const VacTanz = React.lazy(()=>import("./BlogEntries/VacationTanzania"))
const Livingstone = React.lazy(()=> import("./BlogEntries/Livingstone"))

export const AllTags = [
    "Angeheftet",
    "Information",
    "Einträge",
    "Neu"
]


// Bilder sind im Format 4:3

export let Sites = {
    "/home": {
        "link": "/home",
        "title": "Home",
        "component": <Suspense fallback={<MyLoader/>}><HomePage/></Suspense>,
        "type": "main"
    },
    "/about": {
        "link": "/about",
        "title": "About",
        "component": <Suspense fallback={<MyLoader/>}><AboutPage/></Suspense>,
        "type": "main"
    },
    "/kontakt": {
        "link": "/kontakt",
        "title": "Kontakt",
        "component": <Suspense fallback={<MyLoader/>}><ContactPage/></Suspense>,
        "type": "main",
    },
    "/404" : {
        "link": "/404",
        "title": "404",
        "component": <Suspense fallback={<MyLoader/>}><ErrorPage/></Suspense>,
        "type": "error",
    },



    "/blog/sambia": {
        "link": "/blog/sambia",
        "title": "Sambia",
        "component": <BlogShell entry_id={"blog-sambia"}
            entry={
            <Suspense fallback={<MyLoader/>}><Sambia/></Suspense>
        } ids={[
            {
                label: "Einleitung",
                id: "segment1",
                order: 1,
            },
            {
                label: "Geographie",
                id: "segment2",
                order: 1,
            },
            {
                label: "Klima",
                id: "segment3",
                order: 2,
            },
            {
                label:"Bevölkerung",
                id: "segment4",
                order: 1,
            },
            {
                label: "Sprache",
                id: "segment5",
                order: 2,
            },
            {
                label: "Religion",
                id: "segment6",
                order: 2,
            },
            {
                label: "Wirtschaft",
                id: "segment7",
                order: 1,
            },
            {
                label: "Politik",
                id: "segment8",
                order: 1,
            }
        ]}/>,
        "type": "blog",
        "categories": ["Information"],
        "image": "./images/sites/aboutSambia/sambia.jpg",
        "date": new Date("2023-06-28"),
        "description": "Ein Bericht über Sambia."
    },
    "/blog/freiwilligendienst": {
        "link": "/blog/freiwilligendienst",
        "title": "Was mache ich?",
        "component": <BlogShell entry_id={"blog-freiwilligendienst"}
            entry={
            <Suspense fallback={<MyLoader/>}><Freiwilligendienst/></Suspense>
        } ids={[
            {
                label: "Was ist mache ich?",
                id: "segment1",
                order: 1,
            },
            {
                label: "Funktion",
                id: "segment2",
                order: 1,
            },
            {
                label: "Prinzip",
                id: "segment3",
                order: 2,
            },
            {
                label: "Unterstützung",
                id: "segment4",
                order: 2,
            }
        ]}/>,
        "type": "blog",
        "categories": ["Information"],
        "image": "./images/sites/weltwaerts/weltwaerts.png",
        "date": new Date("2023-08-29"),
        "description": "Vorstellung des Weltwärts Programms und Ablaufs.",
    },
    "/blog/spenden": {
        "link": "/blog/spenden",
        "title": "Spenden",
        "component": <BlogShell entry_id={"blog-spenden"}
            entry={
            <Suspense fallback={<MyLoader/>}><DonationsPage/></Suspense>
        } ids={[
            {
                label: "Warum Spenden?",
                id:"segment1",
                order:1
            },
            {
                label: "Wie spenden?",
                order:1,
                id:"segment2"
            }
        ]} />,
        "type": "blog",
        "categories": ["Information"],
        "image": "./images/sites/Donations/Spenden.jpg",
        "date": new Date("2023-08-27"),
        "description": "Information zu Spenden und der Finanzierung meines Freiwilligendienstes."
    },
    "/blog/sambia/ankunft": {
        "link": "/blog/sambia/ankunft",
        "title": "Willkommen in Sambia",
        "component": <BlogShell entry_id={"blog-sambia-ankunft"}
            entry={
            <Suspense fallback={<MyLoader/>}><ArrivePage/></Suspense>
        } ids={[
            {
                label: "Ankunft in Sambia",
                id: "segment1",
                order: 1,
            },
            {
                label: "Ankunftsseminar",
                id: "segment2",
                order: 1,
            },
            {
                label: "Fahrt nach Kabwe",
                id: "segment3",
                order: 1,
            }
        ]}/>,
        "type": "blog",
        "categories": ["Einträge", "Angeheftet"],
        "image": "./images/sites/Arrival/FlughafenHamburg.jpg",
        "date": new Date("2023-08-23"),
        "description": "Meine Ankunft in Sambia."
    },
    "/blog/sambia/meine-arbeit": {
        "link": "/blog/sambia/meine-arbeit",
        "title": "Meine Arbeit",
        "type": "blog",
        "categories": ["Einträge", "Angeheftet"],
        "image": "./images/sites/MyWork/EingangRCSH.jpg",
        "date": new Date("2023-10-08"),
        "description": "Meine ersten Eindrücke und meine Aufgaben bei RCSH.",
        "component": <BlogShell entry={<Suspense fallback={<MyLoader/>}><AboutMyWork/></Suspense>} ids={[
            {
                label: "Einführungsphase",
                id: "segment1",
                order: 1,
            },
            {
                label: "Mein erster Arbeitstag",
                id: "first-day",
                order: 1,
            },
            {
                label: "Die erste Arbeitswoche",
                id: "my-first-real-week",
                order: 1,
            },
            {
                label: "Meine Aufgaben",
                id: "my-tasks",
                order: 1,
            },
            {
                label: "Die neue Ambulanz",
                id: "neue-ambulanz",
                order: 1,
            },
        ]} entry_id={"blog-sambia-meine-arbeit"}/>
    },
    "/blog/sambia/alltag": {
        "link": "/blog/sambia/alltag",
        "title": "Mein Alltag",
        "type": "blog",
        "categories": ["Einträge", "Angeheftet"],
        "image": "./images/sites/EverydayLife/Titelbild.jpg",
        "date": new Date("2023-11-26"),
        "description": "Mein aktueller Alltag und die aktuellen Ereigisse.",
        "component": <BlogShell entry={<Suspense fallback={<MyLoader/>}><EverydayLife/></Suspense>} ids={[
            {
                label: "Mein Alltag",
                id: "Alltag",
                order: 1,
            },
            {
                label: "Ereignisse",
                id: "Ereignisse",
                order: 1,
            },
            {
                label: "20 Jahre Hospiz",
                id: "20JahreHospiz",
                order: 2,
            },
            {
                label: "Erster Regen",
                id: "ErsterRegen",
                order: 2,
            },
            {
                label: "Independence Day",
                id: "IndependenceDay",
                order: 2
            }
        ]} entry_id={"blog-sambia-alltag"}/>
    },
    "/blog/sambia/blog-brot": {
        "link": "/blog/sambia/blog-brot",
        "title": "Blogeintrag bei Brot",
        "type": "blog",
        "categories": ["Einträge", "Angeheftet"],
        "image": "./images/sites/Brot/Brot.png",
        "date": new Date("2024-02-13"),
        "description": "Mein Blogeintrag auf der Brot für die Welt Website",
        "component": <BlogShell entry={<Suspense fallback={<MyLoader/>}><BlogBrot/></Suspense>} ids={[
            {
                label: "Mein Alltag",
                id: "Alltag",
                order: 1,
            },
        ]} entry_id={"blog-sambia-alltag"}/>
    },
    "/blog/sambia/tansania": {
        "link": "/blog/sambia/tansania",
        "title": "Urlaub in Tansania",
        "type": "blog",
        "categories": ["Einträge", "Urlaub", "Angeheftet"],
        "image": "./images/sites/VacTanz/Strand.jpg",
        "date": new Date("2024-02-13"),
        "description": "Mein erster Urlaub in Tansania",
        "component": <BlogShell entry={<Suspense fallback={<MyLoader/>}><VacTanz/></Suspense>} ids={[
            {
                label: "Anreise",
                id: "anreise",
                order: 1,
            },
            {
                label: "Der Zug",
                id: "zug",
                order: 2,
            },
            {
                label: "Tansania und Sansibar",
                id: "tansundsans",
                order: 2,
            },
            {
                label: "Cholera und Anderes ...",
                id: "choleraundanderes",
                order: 1,
            },
        ]} entry_id={"blog-sambia-tansania"}/>
    },
    "/blog/sambia/livingstone": {
        "link": "/blog/sambia/livingstone",
        "title": "Urlaub in Livingstone",
        "type": "blog",
        "categories": ["Einträge", "Urlaub", "Angeheftet", "Neu"],
        "image": "./images/sites/Livingstone/Titelbild.jpg",
        "date": new Date("2024-04-20"),
        "description": "Mein Kurzurlaub in Livingstone",
        "component": <BlogShell entry={<Suspense fallback={<MyLoader/>}><Livingstone/></Suspense>} ids={[
            {
                label: "Los gehts",
                id: "letsgo",
                order: 1,
            },
            {
                label: "Chobe-Nationalpark",
                id: "chobe",
                order: 2,
            },
            {
                label: "Victoriafälle",
                id: "victoriafälle",
                order: 2,
            },
            {
                label: "Mein Ostern",
                id: "ostern",
                order: 1,
            },
        ]} entry_id={"blog-sambia-livingstone"}/>
    }
}

if (settings.impressum) {
    // @ts-ignore
    Sites["/impressum"] = {
        "link": "/impressum",
        "title": "Impressum",
        "component": <Suspense fallback={<MyLoader/>}><ImpressumPage/></Suspense>,
        "type": "main"
    }
}
